import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { NotificationService } from 'src/app/services/notification.service';
import { CarModel, Manufacturer } from 'src/typings';
import { CarModelService } from '../car-model.service';

@Component({
  selector: 'app-create-car-model',
  templateUrl: './create-car-model.component.html',
  styleUrls: ['./create-car-model.component.scss']
})
export class CreateCarModelComponent {
  @Input() dialogRef: MatDialogRef<CreateCarModelComponent> | undefined;

  @Input() set manufacturer(manufacturer: Manufacturer | undefined) {
    this._manufacturer = manufacturer;
    if (manufacturer) {
      this.createForm.controls.manufacturer.setValue(manufacturer);
    }
  }

  @Output() modelCreateEvent: EventEmitter<CarModel> = new EventEmitter();

  _manufacturer: Manufacturer | undefined;

  createForm: UntypedFormGroup = this.fb.group({
    description: new UntypedFormControl(),
    date_from: new UntypedFormControl(),
    date_to: new UntypedFormControl(),
    body: new UntypedFormControl(),
    manufacturer: new UntypedFormControl()
  });

  constructor(
    private fb: UntypedFormBuilder,
    private carModelService: CarModelService,
    private notificationService: NotificationService
  ) {}

  create() {
    this.carModelService
      .create({
        description: this.createForm.value.description,
        date_from: this.createForm.value.date_from,
        date_to: this.createForm.value.date_to,
        body: this.createForm.value.body,
        manufacturer_id: this.createForm.value.manufacturer.id
      })
      .subscribe((newCarModel) => {
        this.dialogRef?.close();
        this.notificationService.notice('Модель создана!');
        this.modelCreateEvent.emit(newCarModel);
      });
  }
}
